import { render, staticRenderFns } from "./TwEntityButtonsForCombine.vue?vue&type=template&id=116e89a0&"
import script from "./TwEntityButtonsForCombine.vue?vue&type=script&lang=js&"
export * from "./TwEntityButtonsForCombine.vue?vue&type=script&lang=js&"
import style0 from "./TwEntityButtonsForCombine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports